import { atom, selector } from 'recoil';
import { Notices } from '@/sdk/data-contracts';

export const noticeListRecoil = atom<Notices[]>({
  key: 'noticeListRecoil',
  default: [],
});
